import type { CallListItem } from 'bundles/connect/types';

export const selectCallListItems = (state): CallListItem[] => state.results.callListItems;

export const selectTotal = (state): number => state.results.total;

export const selectPage = (state): number => state.results.page;

export const selectTotalPages = (state): number => state.results.totalPages;

export const selectDetailedResults = (state): any[] => state.results.detailedResults;
